import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';

type GaSearchScriptsProps = {
	totalResults: number;
	q: string | undefined;
	topics: string[] | undefined;
	access: string[] | undefined;
	learning: string[] | undefined;
	resources: string[] | undefined;
};

export default function GaSearchScripts(props: GaSearchScriptsProps): JSX.Element {
	const router = useRouter();

	const dataLayer = `
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': '${props.totalResults === 0 ? 'noSearchResults' : 'searchResults'}',
      'resultCount': ${props.totalResults},
      'searchTerm': '${props.q}',
      'topics': '${props.topics}',
      'contentAccess': '${props.access}',
      'learningType': '${props.learning}',
      'typesResource': '${props.resources}',
    });
  `;

	useEffect(() => {
		const googleAnalyticsTags = document.getElementById('google-analytics-tags-searchresults');
		googleAnalyticsTags?.replaceChildren(dataLayer);
	}, [props.totalResults, props.q, props.topics, props.access, props.learning, props.resources, router.asPath, dataLayer]);

	return (
		<Script id="google-analytics-tags-searchresults" strategy="afterInteractive">
			{dataLayer}
		</Script>
	);
}
